(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __moduleCache = /* @__PURE__ */ new WeakMap();
  var __toCommonJS = (from) => {
    var entry = __moduleCache.get(from),
      desc;
    if (entry) return entry;
    entry = __defProp({}, "__esModule", { value: true });
    if ((from && typeof from === "object") || typeof from === "function")
      __getOwnPropNames(from).map(
        (key) =>
          !__hasOwnProp.call(entry, key) &&
          __defProp(entry, key, {
            get: () => from[key],
            enumerable:
              !(desc = __getOwnPropDesc(from, key)) || desc.enumerable,
          }),
      );
    __moduleCache.set(from, entry);
    return entry;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, {
        get: all[name],
        enumerable: true,
        configurable: true,
        set: (newValue) => (all[name] = () => newValue),
      });
  };

  // assets/scripts/product/product-form.ts
  var exports_product_form = {};
  __export(exports_product_form, {
    ProductForm: () => ProductForm,
  });

  // ../../packages/utils/src/index.ts
  var tryCatch = async (promiseOrFn, options) => {
    try {
      const data = await (typeof promiseOrFn === "function"
        ? promiseOrFn()
        : promiseOrFn);
      try {
        options?.onSuccess?.(data);
      } catch {}
      return [data, null];
    } catch (error) {
      try {
        options?.onError?.(error);
      } catch {}
      return [null, error];
    } finally {
      try {
        options?.onSettled?.();
      } catch {}
    }
  };
  // utils/components/cart-performance.ts
  class CartPerformance {
    static #metric_prefix = "cart-performance";
    static createStartingMarker(benchmarkName) {
      const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
      return performance.mark(`${metricName}:start`);
    }
    static measureFromEvent(benchmarkName, event) {
      const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
      const startMarker = performance.mark(`${metricName}:start`, {
        startTime: event.timeStamp,
      });
      const endMarker = performance.mark(`${metricName}:end`);
      performance.measure(
        metricName,
        `${metricName}:start`,
        `${metricName}:end`,
      );
    }
    static measureFromMarker(benchmarkName, startMarker) {
      const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
      const endMarker = performance.mark(`${metricName}:end`);
      performance.measure(metricName, startMarker.name, `${metricName}:end`);
    }
    static measure(benchmarkName, callback) {
      const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
      const startMarker = performance.mark(`${metricName}:start`);
      callback();
      const endMarker = performance.mark(`${metricName}:end`);
      performance.measure(
        metricName,
        `${metricName}:start`,
        `${metricName}:end`,
      );
    }
  }
  // utils/fetchConfig.ts
  var fetchConfig = (type = "json") => {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  };

  // assets/scripts/product/product-form.ts
  class ProductForm extends HTMLElement {
    form;
    cart;
    submitButton;
    submitButtonText;
    hideErrors;
    error = false;
    errorMessageWrapper = null;
    errorMessage = null;
    constructor() {
      super();
      const form = this.querySelector("form");
      if (!form) {
        throw new Error("Product form element requires a form child");
      }
      this.form = form;
      this.variantIdInput.disabled = false;
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.cart = document.querySelector("cart-drawer");
      const submitButton = this.querySelector('[type="submit"]');
      if (!submitButton) {
        throw new Error("Product form requires a submit button");
      }
      this.submitButton = submitButton;
      const submitButtonText = this.submitButton.querySelector("span");
      if (!submitButtonText) {
        throw new Error("Submit button requires a span element");
      }
      this.submitButtonText = submitButtonText;
      if (document.querySelector("cart-drawer")) {
        this.submitButton.setAttribute("aria-haspopup", "dialog");
      }
      this.hideErrors = this.dataset.hideErrors === "true";
    }
    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute("aria-disabled") === "true") {
        return;
      }
      this.handleErrorMessage();
      this.submitButton.setAttribute("aria-disabled", "true");
      this.submitButton.classList.add("loading");
      const spinner = this.querySelector(".loading__spinner");
      if (spinner) {
        spinner.classList.remove("hidden");
      }
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      const formData = new FormData(this.form);
      if (this.cart) {
        const sections = this.cart
          .getSectionsToRender()
          .map((section) => section.id);
        formData.append("sections", sections.join(","));
        formData.append("sections_url", window.location.pathname);
        if (document.activeElement)
          this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      const [fetchResponse, fetchError] = await tryCatch(
        fetch(routes.cart_add_url, config),
      );
      if (fetchError) {
        console.error(fetchError);
        this.cleanup(evt, spinner);
        return;
      }
      const response = await fetchResponse.json();
      if (response.status) {
        window.publish(window.PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: formData.get("id"),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);
        const soldOutMessage =
          this.submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) {
          this.cleanup(evt, spinner);
          return;
        }
        this.submitButton.setAttribute("aria-disabled", "true");
        this.submitButtonText.classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
        this.error = true;
        this.cleanup(evt, spinner);
        return;
      }
      if (!this.cart) {
        window.location.href = routes.cart_url;
        return;
      }
      const startMarker = CartPerformance.createStartingMarker(
        "add:wait-for-subscribers",
      );
      if (!this.error) {
        await window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: formData.get("id"),
          cartData: response,
        });
        CartPerformance.measureFromMarker(
          "add:wait-for-subscribers",
          startMarker,
        );
      }
      this.error = false;
      const quickAddModal = this.closest("quick-add-modal");
      if (quickAddModal) {
        document.body.addEventListener(
          "modalClosed",
          () => {
            setTimeout(() => {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart?.renderContents(response);
              });
            });
          },
          { once: true },
        );
        quickAddModal.hide(true);
      } else {
        CartPerformance.measure("add:paint-updated-sections", () => {
          this.cart?.renderContents(response);
        });
      }
      this.cleanup(evt, spinner);
    }
    cleanup(evt, spinner) {
      this.submitButton.classList.remove("loading");
      if (this.cart?.classList.contains("is-empty")) {
        this.cart.classList.remove("is-empty");
      }
      if (!this.error) {
        this.submitButton.removeAttribute("aria-disabled");
      }
      if (spinner) {
        spinner.classList.add("hidden");
      }
      CartPerformance.measureFromEvent("add:user-action", evt);
    }
    handleErrorMessage(errorMessage) {
      if (this.hideErrors) {
        return;
      }
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) {
        return;
      }
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute("disabled", "disabled");
        if (text) {
          this.submitButtonText.textContent = text;
        }
      } else {
        this.submitButton.removeAttribute("disabled");
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }
    get variantIdInput() {
      const input = this.form.querySelector("[name=id]");
      if (!input) {
        throw new Error("Product form requires an input with name='id'");
      }
      return input;
    }
  }
  if (!customElements.get("product-form")) {
    customElements.define("product-form", ProductForm);
  }
})();
